import React, { createContext, useState } from "react";
import useCalculator from "./hooks/useCalculator";

const CalculatorContext = createContext({});

export function CalculatorProvider({ children }) {
  const calculator = useCalculator();
  const [contextData, _setContextData] = useState({
    engage_pricing: "current",
  });

  const setContextData = (name, value) => {
    _setContextData((data) => ({
      ...data,
      [name]: value,
    }));
  };

  return (
    <CalculatorContext.Provider
      value={{
        ...calculator,
        contextData,
        setContextData,
      }}
    >
      {children}
    </CalculatorContext.Provider>
  );
}

export default CalculatorContext;
